import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'ngx-alerts';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import {PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-ledgers',
  templateUrl: './ledgers.component.html',
  styleUrls: ['./ledgers.component.scss'],
})
export class LedgersComponent implements OnInit {
  public modalRef: BsModalRef;
  userForm: FormGroup;
  user = '/../../../assets/img/man.svg';
  imageUrl = '/../../../assets/img/man.svg';
  type: string;
  reports = [
    'All Loans', 'Completed Loans',
    'Bodaboda Loan', 'Taxi Loan', 'Micro Loan',
    'Bodaboda Defaulters', 'Taxi Defaulters', 'Micro Defaulters',
    'Bodaboda Recovery', 'Taxi Recovery', 'Micro Recovery',
    'Bodaboda Enforcement', 'Taxi Enforcement', 'Micro Enforcement',
    'Cash Ledger', 'Paid Ledger', 'Borrowed Ledger', 'Commission',
  ];
  User = this.authService.loggedInUserInfo();
  singleReport: any;
  reportsCopy: any;
  totals: any;
  stationName: string;
  p: number;
  total: number;
  errored = false;
  selectionKind: number;
  selectionData: any;
  modalTitle: string;
  lowValue: number = 0;
  highValue: number = 10;
  pageSize: number = 10;
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private authService: AuthServiceService,
    private others: OthersService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
    this.reports.sort();
    this.userForm = this.createFormGroup();
  }

  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }

  pageSizeOptions() {
    return [5, 10, 20, 30, 40, 50, this.singleReport?.length].filter(n => n <= this.singleReport?.length)
  }

  createFormGroup(): any {
    return this.fb.group({
      report_type: this.fb.control('', Validators.compose([])),
      range_date: this.fb.control({value: '', disabled: true}, Validators.compose([])),
    });
  }
  getReportsCopy() {
    return this.reportsCopy || []
  }

  searchResponse(result: any): any {
    if (result.length) this.singleReport = result;
    else this.singleReport = this.reportsCopy;
    this.total = this.singleReport.length
  }

  get fval(): any {
    return this.userForm.controls;
  }

  changeReport(val: any): any {
    // console.log(val);
    this.type = val;
    const date = new Date();
    const startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    this.fetchReports([startDate, endDate], this.type);

    if (
      this.type === 'Cash Ledger' ||
      this.type === 'Borrowed Ledger' ||
      this.type === 'Paid Ledger' ||
      this.type === 'Commission')
    {
      this.fval.range_date.enable()
    } else {
      this.fval.range_date.disable()
    }

    if(this.type === 'Specify Type') {
      this.fval.search_by.disable();
      this.fval.range_date.disable()
    }
  }

  fetchReport(val: any): any {
    if (val.length > 1) {
      const startDate = `${val[0].getFullYear()}-${val[0].getMonth() + 1}-${val[0].getDate()}`;
      const endDate = `${val[1].getFullYear()}-${val[1].getMonth() + 1}-${val[1].getDate()}`;
      this.fetchReports([startDate, endDate], this.type);
    }
  }
  fetchReports(dates: Array<string>, typeOfReport: string): any {
    switch (typeOfReport) {
      case 'Cash Ledger':
        this.p = 1;
        this.total = 0;
        this.others.getCashLedgerStation({
          theStationLocationId: this.User.userLocationId,
          startDate: dates[0],
          endDate: dates[1],
        }).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Borrowed Ledger':
        this.p = 1;
        this.total = 0;
        this.others.getBorrowedLedgerStation({
          theStationLocationId: this.User.userLocationId,
          startDate: dates[0],
          endDate: dates[1],
        }).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Paid Ledger':
        this.p = 1;
        this.total = 0;
        this.others.getPaidLedgerStation({
          theStationLocationId: this.User.userLocationId,
          startDate: dates[0],
          endDate: dates[1],
        }).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'All Loans':
        this.p = 1;
        this.total = 0;
        this.others.getAllLoansByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Revenue Ledger':
        this.p = 1;
        this.total = 0;
        this.others.getAllRevenueTown({
          theTownLocationId: this.User.userLocationId,
          startDate: dates[0],
          endDate: dates[1],
        }).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Bodaboda Loan':
        this.p = 1;
        this.total = 0;
        this.others.getAllBodaBodaLoansByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Loan':
        this.p = 1;
        this.total = 0;
        this.others.getAllTaxiLoansByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Micro Loan':
        this.p = 1;
        this.total = 0;
        this.others.getAllMicroLoansByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Commission':
        this.p = 1;
        this.total = 0;
        this.others.getCommisionStation({
          theStationLocationId: this.User.userLocationId,
          startDate: dates[0],
          endDate: dates[1],
        }).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Completed Loans':
        this.p = 1;
        this.total = 0;
        this.others.getAllCompletedLoansByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Bodaboda Defaulters':
        this.p = 1;
        this.total = 0;
        this.others.getAllBodaBodaLoanDefaultersByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Defaulters':
        this.p = 1;
        this.total = 0;
        this.others.getAllTaxiLoanDefaultersByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Micro Defaulters':
        this.p = 1;
        this.total = 0;
        this.others.getAllMicroLoanDefaultersByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Bodaboda Recovery':
        this.p = 1;
        this.total = 0;
        this.others.getAllBodaBodaLoanRecoveryByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Recovery':
        this.p = 1;
        this.total = 0;
        this.others.getAllTaxiLoanRecoveryByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Micro Recovery':
        this.p = 1;
        this.total = 0;
        this.others.getAllMicroLoanRecoveryByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Bodaboda Enforcement':
        this.p = 1;
        this.total = 0;
        this.others.getAllBodaBodaLoanEnforcementByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Enforcement':
        this.p = 1;
        this.total = 0;
        this.others.getAllTaxiLoanEnforcementByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Micro Enforcement':
        this.p = 1;
        this.total = 0;
        this.others.getAllMicroLoanEnforcementByStation(this.User.userLocationId).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
    }
  }
  public openModal(template: TemplateRef<any>, photoUrl?: string): any {
    this.imageUrl = photoUrl;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-dialog-centered' })
    );
  }
  pageChanged(event): any {
    this.p = event;
  }
}

